import type { SlideProps } from "@/engine/app/offsite-config";

/**
 * Workshop-Einstieg: Woran erkennt ein Team einen guten Anwendungsfall?
 *
 * Die größte Hürde der Teamarbeit ist die Themenfindung (Briefing Maik):
 * Diese Folie gibt die zwei Filterkriterien als Gegenüberstellung und vier
 * Aktivierungsfragen als Zündfunken mit. Sie bleibt stehen, während die
 * Teamleiter ihre vorbereiteten Kandidaten mit dem Team besprechen.
 */

// „Wiederkehrend" steht schon in der Unterzeile — zwei Zeilen reichen,
// damit die Fragen-Chips unten nicht mit der Fortschrittsleiste kollidieren.
const GEEIGNET = [
  {
    beispiel: "Daten liegen in Systemen: kVASy, Excel, Portal, Postfach",
    gegen: "Steckt nur in Köpfen und Erfahrung",
  },
  {
    beispiel: "Abtippen, abgleichen, übertragen — klare Regeln",
    gegen: "Ermessensentscheidung aus Fachkompetenz",
  },
];

const FRAGEN = [
  "Wo tippst du von System zu System?",
  "Welche Liste gleicht ihr von Hand ab?",
  "Was baut ihr jeden Monat neu?",
  "Wo stapeln sich Anhänge im Postfach?",
];

export function Slide12Aktivierung(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Euer Anwendungsfall</div>
        <h1 className="deck-title rise rise-2">
          Woran ihr ein <br />
          <span className="accent">gutes Thema erkennt</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Wiederkehrend, aus Systemdaten, mit klaren Regeln — das kann die KI.
          Entscheidungen bleiben bei euch.
        </p>
      </header>

      <div className="status-grid rise rise-4">
        <div className="status-headers">
          <div className="pos">Gut geeignet</div>
          <div className="neg">Eher nicht</div>
        </div>
        {GEEIGNET.map((r) => (
          <div key={r.beispiel} className="status-row">
            <div className="status-cell pos">
              <span className="status-mark pos">✓</span>
              <span className="status-text">{r.beispiel}</span>
            </div>
            <div className="status-cell neg">
              <span className="status-mark neg">✕</span>
              <span className="status-text">{r.gegen}</span>
            </div>
          </div>
        ))}
      </div>

      <div
        className="rise rise-5"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          marginTop: 12,
        }}
      >
        {FRAGEN.map((f) => (
          <div
            key={f}
            style={{
              background: "rgba(255,255,255,0.07)",
              border: "1px solid rgba(255,255,255,0.16)",
              borderRadius: 12,
              padding: "10px 12px",
              fontSize: "clamp(0.8rem, 1.1vw, 1rem)",
              color: "rgba(255,255,255,0.9)",
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <span aria-hidden="true" style={{ color: "var(--svo-gruen)" }}>
              ⚡
            </span>
            {f}
          </div>
        ))}
      </div>
    </div>
  );
}
